import { MouseEventHandler } from "react";

import plusGreen from "./green_plus_icon.png";
import plusDark from "./plus_icon_24px_dark.png";
import plusLight from "./plus_icon_24px_light.png";

type PlusIconProps = {
  color?: "dark" | "light" | "green";
  handlePlusClicked?: MouseEventHandler<HTMLImageElement>;
};

const PLUS_IMAGES: Record<"dark" | "light" | "green", string> = {
  dark: plusDark,
  light: plusLight,
  green: plusGreen,
};

export const PlusIcon = ({ color, handlePlusClicked }: PlusIconProps) => (
  <img
    src={PLUS_IMAGES[color || "dark"]}
    alt="Plus icon"
    onClick={handlePlusClicked}
  />
);
